module.exports = __webpack_public_path__ + "static/feature-3-12951ebed31cf4026eec4b7eaa92bf7a.svg";